import { Link } from "react-router-dom";
import { AdminHead } from "./AdminLayout";
import { useGet } from "../../lib/api";

const Stat = ({ label, value, accent, testid, to }) => (
  <Link to={to} className="card-lift rounded-3xl border bg-white p-6" data-testid={testid}>
    <p className="text-sm text-[var(--ink)]/60">{label}</p>
    <p className={`mt-2 font-display text-4xl font-semibold ${accent}`}>{value ?? "-"}</p>
  </Link>
);

export default function AdminDashboard() {
  const { data: s } = useGet("stats", "/admin/stats");
  return (
    <>
      <AdminHead title="Dashboard" desc="Ringkasan konten website Sembada Satwa." />
      <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
        <Stat label="Total Sapi" value={s?.cattle_total} accent="text-[var(--forest)]" testid="stat-cattle-total" to="/admin/sapi" />
        <Stat label="Sapi Tersedia" value={s?.cattle?.Tersedia} accent="text-emerald-600" testid="stat-cattle-tersedia" to="/admin/sapi" />
        <Stat label="Sapi Terpesan" value={s?.cattle?.Terpesan} accent="text-amber-500" testid="stat-cattle-terpesan" to="/admin/sapi" />
        <Stat label="Sapi Terjual" value={s?.cattle?.Terjual} accent="text-red-600" testid="stat-cattle-terjual" to="/admin/sapi" />
        <Stat label="Artikel" value={s?.articles} accent="text-[var(--earth)]" testid="stat-articles" to="/admin/artikel" />
        <Stat label="Banner Aktif" value={s?.banners_active} accent="text-[var(--gold-dark)]" testid="stat-banners-active" to="/admin/banner" />
      </div>
    </>
  );
}
